import { CartMessage } from "./cart-message";
import {CartProductView} from './cart-product';
import { CartSampleView } from './cart-sample';
// import { noCartProductTemplate, noCartSamplesTemplate, cartSummaryTemplate, cartEmptyTemplate } from '../templates';

var SideCart = Backbone.View.extend({
    el: '#side-cart',
    events: {
        'click .close-cart': 'closeCart',
        'click .backdrop': 'closeCart',
        'click .keep-shopping': 'closeCart'
    },
    initialize: function(){
        _.bindAll(
            this,
            'showFlyout',
            'render',
            'renderContents',
            'closeCart',
            'showFlyout',
            'addMessage',
            'addSamples',
            'addSample',
            'addProduct',
            'addProducts',
            'renderMessages',
            'resetMessages',
            'updateProductsCount', 
            'updateSamplesCount'
        );
        this.template = _.template( document.getElementById('side-cart-template').innerHTML );
        this.messageViews = [];
        this.productViews = [];
        this.sampleViews = [];

        this.cartEmptyTemplate = document.getElementById('cart-empty-template').innerHTML;
        this.cartSummaryTemplate = _.template(document.getElementById('empty-cart-products-template').innerHTML );
        this.noCartSamplesTemplate = _.template(document.getElementById('empty-cart-samples-template').innerHTML );
        this.noCartProductTemplate = _.template(document.getElementById('empty-cart-products-template').innerHTML );

        this.listenTo( this.model, 'message', this.renderMessages );
        this.listenTo( this.model, 'update_cart', this.renderContents );
        this.listenTo( this.model, 'product_added', this.addProducts );
        this.listenTo( this.model, 'sample_added', this.addSamples );
        this.rendered = false;
        // this.listenTo( this.model, 'change', this.render );
    },
    render: function(){
        var output = this.template({});
        this.$el.html( output );
        this.renderContents();
    },
    renderContents: function(){
        if ( this.model.get( 'count' ) ) { 
            this.addProducts();
            this.addSamples();
            this.renderMessages();
            // this.renderForm();
            // this.updateCartSummary();
            // this.rendered = true;
        } else {
                this.$('.cart-yield').html( this.cartEmptyTemplate );
            
        }
    },
    /**
     * showFlyout
     * 
     * Add a class to the element to trigger the cart to show
     * 
     */
    showFlyout: function(){
        this.render();
        this.$el.removeClass( 'slide-out' );
        this.$el.toggleClass( 'show' );
    },
    /**
     * closeCart
     * 
     * add a class to animate the cart out, 
     * then remove the class which shows it afte a timeout (to wait for animation)
     * 
     * @param {event} e 
     */
    closeCart: function( e ){
        e.preventDefault();
        this.$el.addClass( 'slide-out' );
        var self = this;
        setTimeout(function(){
            self.$el.removeClass( 'show' );
        }, 360);
    },
    resetMessages: function(){
        _.each( this.messageViews, function( view ){ view.remove(); });
        // this.$('.cart-messages').html( '' );
    },
    renderMessages: function(){
        this.resetMessages();
        var messages = this.model.get( 'messages' );
        messages.each( this.addMessage );
    },
    addMessage: function( message ){
        if ( ! message.get('shown') ) {
            var v = new CartMessage({ model: message });
            this.$('.cart-messages').append( v.el );
            message.set({ 'shown' : true });
            this.messageViews.push( v );
        }
    },

    /**
     * addSamples
     * 
     * add each sample from the collection.
     * if it is empty note that it is empty,
     * if it has already rendered, skip rendering again, 
     * new samples can't be added from this view, subviews will be updated
     * 
     * @returns VOID
     */
    addSamples: function(){

        var samples = this.model.get( 'samples' );
        this.updateSamplesCount();

        _.each( this.sampleViews, function( v ) {
            v.remove();
        } );

        if ( samples.length ) {
            samples.each(this.addSample);
        } else {
            var empty = this.noCartSamplesTemplate({});

            this.$( '.cart-samples' ).html( empty );
        }
    },
    updateSamplesCount: function (){
        var samples = this.model.get( 'samples' );
        this.$('.samples-count').text( '(' + samples.length  +')');
    },
    /**
     * addSample
     * 
     * add individual samples from the collection for each loop
     * @param {model} sample 
     */
    addSample: function( sample ){
        var sampleView = new CartSampleView({ model: sample });
        sampleView.render();
        this.$( '.cart-samples' ).append( sampleView.el );
        this.sampleViews.push( sampleView );
    },
    /**
     * addProducts
     * 
     * add each product from the collection.
     * if it is empty note that it is empty,
     * if it has already rendered, skip rendering again, 
     * new products can't be added from this view, subviews will be updated
     * 
     * @returns VOID
     */
    addProducts: function(){
        var products = this.model.get( 'products' );
        this.updateProductsCount();
        _.each( this.productViews, function( v ) {
            v.remove();
        } );
        this.productViews = [];
        this.$( '.cart-products' ).html( '' );
        
        if ( products.length ) {
            products.each(this.addProduct);
        } else {
            var empty = this.noCartProductTemplate({});

            this.$( '.cart-products' ).html( empty );
        }
    },
    updateProductsCount: function (){
        var products = this.model.get( 'products' );
        this.$('.products-count').text( '(' + products.length  +')');
    },
    /**
     * addProduct
     * 
     * add an individual product from the colleciton (callback for each loop)
     * 
     * @param {model|obj} prod 
     */
    addProduct: function( prod ){
        this.listenTo( prod, 'change', this.makeCartDetails );
        var productView = new CartProductView({ model: prod });
        productView.render();
        this.$( '.cart-products' ).append( productView.el );
        this.productViews.push( productView );
    }
});

export {SideCart};